<template>
    <div class="d-flex align-items-center w-100">
        <div class="w-70">
            <b-progress :value="clampedValue" :max="100" :variant="variant" height="8px" class="mb-0" />
        </div>
        <div class="w-30 text-right pl-50">
            <span class="font-weight-bold font-small-3 text-nowrap">{{ percentageFormatted }}</span>
        </div>
    </div>
</template>

<script>
import { BProgress } from "bootstrap-vue";

export default {
    name: "StorageFillRate",
    components: { BProgress },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        rawPercentage() {
            const current = this.row.FuelQuantity || 0;
            const capacity = this.row.Capacity || 0;
            if (capacity <= 0) return 0;
            return (current / capacity) * 100;
        },
        clampedValue() {
            return Math.min(Math.max(this.rawPercentage, 0), 100);
        },
        percentageFormatted() {
            return Math.round(this.rawPercentage);
        },
        variant() {
            if (this.rawPercentage > 100) return "danger";
            if (this.rawPercentage > 90) return "warning";
            return "success";
        },
    },
};
</script>
